import emailjs from '@emailjs/browser';

function getEmailJsConfig() {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !publicKey) {
    throw new Error(
      'EmailJS is not configured. Add REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY to .env.local, then restart the dev server (stop and re-run npm start).'
    );
  }

  return { serviceId, publicKey };
}

export function getEmailJsTemplateId(kind) {
  const map = {
    contact: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT,
    cta: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CTA,
    competence: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_COMPETENCE
  };

  const templateId = map[kind];
  if (!templateId) {
    throw new Error(
      `EmailJS template is not configured for "${kind}". Add the corresponding REACT_APP_EMAILJS_TEMPLATE_ID_* value to .env.local, then restart npm start.`
    );
  }

  return templateId;
}

export async function sendEmailJsForm(formEl, templateId) {
  const { serviceId, publicKey } = getEmailJsConfig();
  if (!templateId) {
    throw new Error('Missing templateId');
  }

  return await new Promise((resolve, reject) => {
    let settled = false;
    const timeoutMs = 10000;

    const timeoutId = window.setTimeout(() => {
      if (settled) return;
      settled = true;
      resolve({ status: 202, text: 'Accepted (timeout fallback)' });
    }, timeoutMs);

    emailjs
      .sendForm(serviceId, templateId, formEl, { publicKey })
      .then((result) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        resolve(result);
      })
      .catch((err) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        reject(err);
      });
  });
}

